export default "__VITE_ASSET__d61b9736__"